// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3hiAi","noInteraction":"EventWrapper_noInteraction__3Py3V","pointerPassthrough":"EventWrapper_pointerPassthrough__2sCWU"};